export function classIf(el, className, add) {
  if (add) el.classList.add(className)
  else el.classList.remove(className)
}
